/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OfferStatus } from './OfferStatus';
import {
    OfferStatusFromJSON,
    OfferStatusFromJSONTyped,
    OfferStatusToJSON,
} from './OfferStatus';
import type { OfferSubmissionDocument } from './OfferSubmissionDocument';
import {
    OfferSubmissionDocumentFromJSON,
    OfferSubmissionDocumentFromJSONTyped,
    OfferSubmissionDocumentToJSON,
} from './OfferSubmissionDocument';
import type { OfferTerms } from './OfferTerms';
import {
    OfferTermsFromJSON,
    OfferTermsFromJSONTyped,
    OfferTermsToJSON,
} from './OfferTerms';
import type { PublicListing } from './PublicListing';
import {
    PublicListingFromJSON,
    PublicListingFromJSONTyped,
    PublicListingToJSON,
} from './PublicListing';
import type { StatusReason1 } from './StatusReason1';
import {
    StatusReason1FromJSON,
    StatusReason1FromJSONTyped,
    StatusReason1ToJSON,
} from './StatusReason1';

/**
 * 
 * @export
 * @interface PublicOffer
 */
export interface PublicOffer {
    /**
     * 
     * @type {string}
     * @memberof PublicOffer
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicOffer
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof PublicOffer
     */
    addressStr: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof PublicOffer
     */
    status: OfferStatus;
    /**
     * 
     * @type {string}
     * @memberof PublicOffer
     */
    mlsId?: string;
    /**
     * 
     * @type {Array<OfferSubmissionDocument>}
     * @memberof PublicOffer
     */
    submissionDocuments?: Array<OfferSubmissionDocument>;
    /**
     * 
     * @type {Date}
     * @memberof PublicOffer
     */
    receivedAt?: Date;
    /**
     * 
     * @type {Array<OfferTerms>}
     * @memberof PublicOffer
     */
    terms?: Array<OfferTerms>;
    /**
     * 
     * @type {Date}
     * @memberof PublicOffer
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicOffer
     */
    updatedAt: Date;
    /**
     * 
     * @type {PublicListing}
     * @memberof PublicOffer
     */
    listing: PublicListing;
    /**
     * 
     * @type {StatusReason1}
     * @memberof PublicOffer
     */
    statusReason?: StatusReason1;
}

/**
 * Check if a given object implements the PublicOffer interface.
 */
export function instanceOfPublicOffer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "listingId" in value;
    isInstance = isInstance && "addressStr" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "listing" in value;

    return isInstance;
}

export function PublicOfferFromJSON(json: any): PublicOffer {
    return PublicOfferFromJSONTyped(json, false);
}

export function PublicOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicOffer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listingId': json['listing_id'],
        'addressStr': json['address_str'],
        'status': OfferStatusFromJSON(json['status']),
        'mlsId': !exists(json, 'mls_id') ? undefined : json['mls_id'],
        'submissionDocuments': !exists(json, 'submission_documents') ? undefined : ((json['submission_documents'] as Array<any>).map(OfferSubmissionDocumentFromJSON)),
        'receivedAt': !exists(json, 'received_at') ? undefined : (new Date(json['received_at'])),
        'terms': !exists(json, 'terms') ? undefined : ((json['terms'] as Array<any>).map(OfferTermsFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'listing': PublicListingFromJSON(json['listing']),
        'statusReason': !exists(json, 'status_reason') ? undefined : StatusReason1FromJSON(json['status_reason']),
    };
}

export function PublicOfferToJSON(value?: PublicOffer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listing_id': value.listingId,
        'address_str': value.addressStr,
        'status': OfferStatusToJSON(value.status),
        'mls_id': value.mlsId,
        'submission_documents': value.submissionDocuments === undefined ? undefined : ((value.submissionDocuments as Array<any>).map(OfferSubmissionDocumentToJSON)),
        'received_at': value.receivedAt === undefined ? undefined : (value.receivedAt.toISOString()),
        'terms': value.terms === undefined ? undefined : ((value.terms as Array<any>).map(OfferTermsToJSON)),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'listing': PublicListingToJSON(value.listing),
        'status_reason': StatusReason1ToJSON(value.statusReason),
    };
}

